<div class="file-element">
  <cigna-icon type="file" class="file-icon"></cigna-icon>
  <a class="file-name" (click)="openFileNewTab()">{{ transformedName }}</a>
</div>
